import { useSelector } from "react-redux";

import { useBaseRowActions } from "../bulkPayments/bulkBase";

import { BulkTemplateForm, TemplateRowInitialValue } from "./BulkTemplate.form";
import {
  selectFormattedPaginatedBulkTemplates,
  selectBulkTemplatesTotal,
} from "./selectors";

export const useCreateBulkTemplateRowActions = () => {
  const form = BulkTemplateForm.useForm();
  const { addRow: baseAddRow, ...rowActions } = useBaseRowActions(form);

  const addRow = () => {
    baseAddRow({ ...TemplateRowInitialValue });
  };

  return {
    addRow,
    ...rowActions,
  };
};

export const useFormattedPaginatedBulkTemplates = (pageNumber: number) => {
  return useSelector((state) =>
    selectFormattedPaginatedBulkTemplates(state, pageNumber),
  );
};

export const useBulkTemplatesTotal = () => {
  return useSelector(selectBulkTemplatesTotal);
};
